import React, {useState, useRef} from "react";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	Fade,
	IconButton,
	Typography
} from "@mui/material";
import {useTranslation} from "react-i18next";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";
import PopoverList from "../PopoverList";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Fade ref={ref} {...props} />;
});

const ModalComponent = ({title, titleIcon, open, handleClose, handleOk, okDisabled = false, children, okString, cancelString, moreOptions}) => {
	const [showMoreIsOpen, setShowMoreIsOpen] = useState(false);
	const { t } = useTranslation();
	const moreOptionsButtonRef = useRef(null);

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			PaperProps={{ sx: { width: "500px", height: "600px" } }}
			TransitionComponent={Transition}
			scroll="paper"
		>
			<DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center", px: 3, py: 1}}>
				<Box sx={{display: "flex", alignItems: "center", py: 2}}>
					{titleIcon}
					<Typography variant="h3" fontWeight={500}>
						{title}
					</Typography>
				</Box>
				{moreOptions && moreOptions.length > 0 &&
					<>
						<IconButton
							onClick={() => setShowMoreIsOpen(!showMoreIsOpen)}
							ref={moreOptionsButtonRef}
						>
							<MoreVertIcon fontSize="medium" />
						</IconButton>
						{moreOptionsButtonRef.current &&
							<PopoverList
								ref={moreOptionsButtonRef}
								buttons={moreOptions}
								open={showMoreIsOpen}
								handleClose={() => setShowMoreIsOpen(false)}
							/>
						}
					</>
				}
			</DialogTitle>
			<DialogContent>
				<>
					{children}
				</>
			</DialogContent>
			{(handleClose !== undefined || handleOk !== undefined) ?
				<Divider variant="middle" />
				:
				null
			}
			<DialogActions>
				{handleClose &&
					<Button onClick={handleClose}>
						{cancelString ?? t("Cancel")}
					</Button>
				}
				{handleOk &&
					<Button disabled={okDisabled} onClick={handleOk}>
						{okString ?? t("Ok")}
					</Button>
				}
			</DialogActions>
		</Dialog>
	);
};
export default ModalComponent;

ModalComponent.propTypes = {
	title: PropTypes.string.isRequired,
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func,
	handleOk: PropTypes.func,
	children: PropTypes.node.isRequired,
	moreOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
};
